import type { IconData } from '@stacksjs/iconify-core'

export const gps: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18.913 2.9L2.632 9.226l4.829 2.006a5.77 5.77 0 0 1 3.118 3.119l2.006 4.828zm1.847.682l-6.328 16.281c-.4 1.03-1.551 1.557-2.571 1.18a1.92 1.92 0 0 1-1.11-1.067l-2.007-4.83a3.85 3.85 0 0 0-2.079-2.078l-4.828-2.006C.833 10.645.375 9.486.814 8.472A2.05 2.05 0 0 1 1.949 7.38L18.23 1.052a1.945 1.945 0 0 1 2.53 2.53\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default gps
